import { render } from "./SegmentPage.vue?vue&type=template&id=8f131136"
import script from "./SegmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentPage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Pathways/SegmentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f131136"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f131136', __exports__)) {
    api.reload('8f131136', __exports__)
  }
  
  module.hot.accept("./SegmentPage.vue?vue&type=template&id=8f131136", () => {
    api.rerender('8f131136', render)
  })

}


export default __exports__